class ProductPriceCalculator extends HTMLElement {
    constructor() {
        super();
        try {
            this.config = typeof window.jsonData === 'string' ? JSON.parse(window.jsonData) : window.jsonData;
        } catch (error) {
            console.error('Error parsing configuration data:', error);
            this.config = {}; // Set a default empty configuration
        }
        this.productId = this.getAttribute('data-product-id');
        this.endpoint = this.getAttribute('data-endpoint');
        this.fileInput = this.querySelector('input[type="file"]');
        this.uploadedFileUrl = null;
        this.currentItemsCountElement = this.querySelector('.current-items-count');
        this.skuElement = this.querySelector('#productSKU');
    }


    connectedCallback() {
        this.initializeForm();
        this.addEventListeners();
        this.calculatePrice();
        this.initializeOntwerpAanleveren();
        this.initializeCloudinaryUpload();
        this.initializeFileUpload();
        this.updateSKU();

        setTimeout(() =>{
          this.calculatePrice();
        }, 1200)
    }

    updateSKU() {
        const sizeElement = this.querySelector('input[name="size"]:checked');

        if (!sizeElement) {
            console.warn('Size is not selected.');
            return;
        }

        const size = sizeElement.value;
        
        // Find the size object in the config
        const sizeObject = this.config.sizes.find(s => s.name === size);
        const sku = sizeObject ? sizeObject.sku : '';

        console.log('Size:', size);
        console.log('Size object:', sizeObject);
        console.log('SKU:', sku);

        if (sku) {
            this.skuElement.textContent = `PP${sku}`;
            this.skuElement.style.display = 'block';
        } else {
            this.skuElement.style.display = 'none';
        }
    }

    initializeFileUpload() {
        const fileInput = this.querySelector('#ontwerpFile');
        const uploadButton = this.querySelector('.upload-button');
        const previewImage = this.querySelector('#fileUploadContainer img');

        uploadButton.addEventListener('click', () => {
            fileInput.click();
        });

        fileInput.addEventListener('change', (event) => {
            const file = event.target.files[0];
            if (file) {
                this.uploadToCloudinary(file);
            }
        });
    }

    initializeCloudinaryUpload() {
        const fileInput = this.querySelector('#ontwerpFile');
        const fileUploadContainer = this.querySelector('#fileUploadContainer');

        fileInput.addEventListener('change', (event) => {
            const file = event.target.files[0];
            if (file) {
                this.uploadToCloudinary(file);
            }
        });
    }

    uploadToCloudinary(file) {
        const uploadPreset = 'ml_default';
        const url = `https://api.cloudinary.com/v1_1/dxizja8yc/upload`;

        const formData = new FormData();
        formData.append('file', file);
        formData.append('upload_preset', uploadPreset);

        fetch(url, {
            method: 'POST',
            body: formData
        })
            .then(response => response.json())
            .then(result => {
                console.log('Success:', result);
                this.uploadedFileUrl = result.secure_url;
                this.updateFileUploadUI(result.secure_url);
                this.querySelector('#fileUploadContainer').classList.add('image-added');
            })
            .catch(error => {
                console.error('Error:', error);
                alert('Failed to upload file. Please try again.');
            });
    }

    updateFileUploadUI(imageUrl) {
        const previewImage = this.querySelector('#fileUploadContainer img');
        const uploadButton = this.querySelector('.upload-button');

        previewImage.src = imageUrl;
        previewImage.style.display = 'block';
        // uploadButton.textContent = 'Change Image';
    }






    initializeOntwerpAanleveren() {
        const ontwerpRadios = this.querySelectorAll('input[name="ontwerpAanleveren"]');
        const fileUploadContainer = this.querySelector('#fileUploadContainer');

        // Set initial state
        if (ontwerpRadios[0].checked) {
            fileUploadContainer.style.display = 'block';
        } else {
            fileUploadContainer.style.display = 'none';
        }

        // Add event listeners
        ontwerpRadios.forEach(radio => {
            radio.addEventListener('change', (event) => {
                if (event.target.value === 'nu') {
                    fileUploadContainer.style.display = 'block';
                } else {
                    fileUploadContainer.style.display = 'none';
                }
            });
        });
    }

    initializeForm() {
        if (!this.config || !this.config.sizes || !this.config.printTypes) {
            console.error('Invalid configuration data');
            return;
        }
        const sizeFieldset = this.querySelector('#sizeFieldset');
        const printTypeFieldset = this.querySelector('#printTypeFieldset');
        const numberOfColorsFieldset = this.querySelector('#numberOfColorsFieldset');
        const quantityFieldset = this.querySelector('#quantityFieldset');
        const shippingFieldset = this.querySelector('#shippingFieldset');

        if (this.config.hiddenOptions.quantity) {
            quantityFieldset.style.display = 'none';
        }
        if (this.config.hiddenOptions.shipping) {
            shippingFieldset.style.display = 'none';
        }

        const createLabelWrapper = () => {
            const wrapper = document.createElement('div');
            wrapper.className = 'label-wrapper';
            return wrapper;
        };

        const sizeWrapper = createLabelWrapper();
        this.config.sizes.forEach(size => {
            const label = document.createElement('label');
            const input = document.createElement('input');
            input.type = 'radio';
            input.name = 'size';
            input.value = size.name;
            input.dataset.imagePosition = size.imagePosition;
            if (size === this.config.sizes[0]) input.checked = true;
            label.appendChild(input);
            label.appendChild(document.createTextNode(size.name));
            sizeWrapper.appendChild(label);
        });
        sizeFieldset.appendChild(sizeWrapper);

        const printTypeWrapper = createLabelWrapper();
        this.config.printTypes.forEach(printType => {
            const label = document.createElement('label');
            const input = document.createElement('input');
            input.type = 'radio';
            input.name = 'printType';
            input.value = printType.name;
            if (printType === this.config.printTypes[0]) input.checked = true;
            label.appendChild(input);
            label.appendChild(document.createTextNode(printType.name));
            printTypeWrapper.appendChild(label);
        });
        printTypeFieldset.appendChild(printTypeWrapper);

        const numberOfColorsWrapper = createLabelWrapper();
        Object.entries(this.config.numberOfColors).forEach(([colorOption, colorInfo]) => {
            const label = document.createElement('label');
            const input = document.createElement('input');
            input.type = 'radio';
            input.name = 'numberOfColors';
            input.value = colorOption;
            
            // Check if this is the first color option
            if (colorOption === Object.keys(this.config.numberOfColors)[0]) {
                input.checked = true;
            }

            const imageSpan = document.createElement('span');
            imageSpan.className = 'color-option-image';

            const textSpan = document.createElement('span');
            textSpan.className = 'color-option-text';
            textSpan.textContent = colorOption;
            
            // Add a data attribute for CMYK options
            const isCMYK = typeof colorInfo === 'object' && colorInfo.isCMYK;
            if (isCMYK) {
                label.dataset.cmyk = 'true';
            }
            
            label.dataset.value = colorOption;
            label.appendChild(input);
            label.appendChild(imageSpan);
            label.appendChild(textSpan);
            numberOfColorsWrapper.appendChild(label);
        });
        numberOfColorsFieldset.appendChild(numberOfColorsWrapper);

        const quantityWrapper = createLabelWrapper();
        Object.keys(this.config.quantities).forEach(quantity => {
            const label = document.createElement('label');
            const input = document.createElement('input');
            input.type = 'radio';
            input.name = 'quantity';
            input.value = quantity;
            if (quantity === Object.keys(this.config.quantities)[0]) input.checked = true;
            label.appendChild(input);
            label.appendChild(document.createTextNode(quantity));
            quantityWrapper.appendChild(label);
        });
        quantityFieldset.appendChild(quantityWrapper);

        const shippingWrapper = createLabelWrapper();
        Object.keys(this.config.shipping).forEach(shippingOption => {
            const label = document.createElement('label');
            const input = document.createElement('input');
            input.type = 'radio';
            input.name = 'shipping';
            input.value = shippingOption;
            if (shippingOption === Object.keys(this.config.shipping)[0]) input.checked = true;
            label.appendChild(input);
            label.appendChild(document.createTextNode(shippingOption));
            shippingWrapper.appendChild(label);
        });
        shippingFieldset.appendChild(shippingWrapper);

        if (this.config.ontwerpAanleveren && this.config.ontwerpAanleveren.enabled) {
            this.querySelector('#ontwerpAanleverenSection').style.display = 'block';
        } else {
            this.querySelector('#ontwerpAanleverenSection').style.display = 'none';
        }

        this.updateAvailableOptions();
        this.updateQuantityOptions();  // Ensure quantity options are updated
    }


    addEventListeners() {
        this.querySelectorAll('input').forEach(input => {
            input.addEventListener('change', (event) => {
                if (event.target.name === 'size' || event.target.name === 'printType' || event.target.name === 'numberOfColors' || event.target.name === 'quantity') {
                    this.updateAvailableOptions();
                } else if (event.target.name === 'shipping') {
                    this.calculatePrice();
                }
                setTimeout(() => {
                    this.calculatePrice();
                }, 600);
            });
        });




        this.querySelector('#addToCartBtn').addEventListener('click', this.addToCart.bind(this));

        const fileInput = this.querySelector('#ontwerpFile');
        fileInput.addEventListener('change', (event) => {
            this.fileToUpload = event.target.files[0];
        });

        const ontwerpRadios = this.querySelectorAll('input[name="ontwerpAanleveren"]');
        ontwerpRadios.forEach(radio => {
            radio.addEventListener('change', this.toggleFileUpload.bind(this));
        });

        // Ensure options are updated on initial load
        this.updateAvailableOptions();
    }

    updateCurrentItemsCount() {
        const quantityElement = this.querySelector('input[name="quantity"]:checked');
        if (quantityElement) {
            const quantity = parseInt(quantityElement.value);
            this.currentItemsCountElement.textContent = quantity;
        }
    }

    parseOptions(optionsString) {
        if (!optionsString || optionsString === 'hidden') return {};

        return optionsString.split(',').reduce((acc, opt) => {
            const lastColonIndex = opt.lastIndexOf(':');
            if (lastColonIndex !== -1) {
                const key = opt.substring(0, lastColonIndex).trim();
                const value = opt.substring(lastColonIndex + 1).trim();
                acc[key] = value;
            }
            return acc;
        }, {});
    }

    updateAvailableOptions() {
        console.log('Entering updateAvailableOptions');
        const selectedSize = this.querySelector('input[name="size"]:checked').value;
        console.log('Selected size:', selectedSize);
        const printTypeFieldset = this.querySelector('#printTypeFieldset');
        const numberOfColorsFieldset = this.querySelector('#numberOfColorsFieldset');

        printTypeFieldset.querySelectorAll('label').forEach(label => label.classList.add('hidden'));
        numberOfColorsFieldset.querySelectorAll('label').forEach(label => label.classList.add('hidden'));

        this.config.printTypes.forEach(printType => {
            console.log(`Checking print type: ${printType.name}`);
            let printTypeHasValidOption = false;
            Object.keys(this.config.numberOfColors).forEach(colorName => {
                const price = this.config.pricingMatrix[selectedSize]?.printOptions[printType.name]?.[colorName];
                const isHidden = this.config.pricingMatrix[selectedSize]?.printOptions[printType.name]?.[`${colorName}_hidden`];
                console.log(`  Color: ${colorName}, Price: ${price}, Hidden: ${isHidden}`);
                if (price !== undefined && price !== null && price > 0 && !isHidden) {
                    printTypeHasValidOption = true;
                }
            });

            if (printTypeHasValidOption) {
                const printTypeLabel = printTypeFieldset.querySelector(`input[value="${printType.name}"]`).parentNode;
                printTypeLabel.classList.remove('hidden');
                console.log(`Showing print type: ${printType.name}`);
            } else {
                console.log(`Hiding print type: ${printType.name}`);
            }
        });

        // Ensure a valid print type is selected
        const selectedPrintType = printTypeFieldset.querySelector('input:checked');
        if (!selectedPrintType || selectedPrintType.parentNode.classList.contains('hidden')) {
            const firstVisiblePrintType = printTypeFieldset.querySelector('label:not(.hidden) input');
            if (firstVisiblePrintType) {
                firstVisiblePrintType.checked = true;
                console.log(`Auto-selecting print type: ${firstVisiblePrintType.value}`);
            }
        }

        // Update number of colors options based on selected print type
        const currentPrintType = printTypeFieldset.querySelector('input:checked').value;
        this.updateNumberOfColorsOptions(currentPrintType);

        this.updateQuantityOptions();
        this.calculatePrice();
        const basePrice = this.calculateBasePrice();
        this.updateShippingPrices(basePrice);

        console.log('Exiting updateAvailableOptions');
        this.updateSKU();

    }

    calculateBasePrice() {
        const sizeElement = this.querySelector('input[name="size"]:checked');
        const printTypeElement = this.querySelector('input[name="printType"]:checked');
        const numberOfColorsElement = this.querySelector('input[name="numberOfColors"]:checked');
        const quantityElement = this.querySelector('input[name="quantity"]:checked');

        const size = sizeElement.value;
        const printType = printTypeElement.value;
        const numberOfColors = numberOfColorsElement.value;
        const quantity = parseInt(quantityElement.value);

        const variantOptions = this.config.pricingMatrix[size]?.printOptions[printType];

        if (!variantOptions || variantOptions[numberOfColors] === undefined) {
            return 0;
        }

        let basePrice = variantOptions[numberOfColors];
        
        // Calculate quantity multiplier
        let quantityMultiplier = 1;
        const specificQuantityOptions = variantOptions[`${numberOfColors}_quantity`];
        if (specificQuantityOptions) {
            const parsedOptions = this.parseOptions(specificQuantityOptions);
            if (parsedOptions[quantity.toString()] !== undefined) {
                quantityMultiplier = parseFloat(parsedOptions[quantity.toString()]) || 1;
            }
        } else {
            // Use global quantity multiplier if no specific one is set
            quantityMultiplier = this.config.quantities[quantity.toString()] || 1;
        }
        
        return basePrice * quantity * quantityMultiplier;
    }


    updateNumberOfColorsOptions(printType) {
        console.log(`Entering updateNumberOfColorsOptions for print type: ${printType}`);
        const selectedSize = this.querySelector('input[name="size"]:checked').value;
        console.log(`Selected size: ${selectedSize}`);
        const numberOfColorsFieldset = this.querySelector('#numberOfColorsFieldset');

        numberOfColorsFieldset.querySelectorAll('label').forEach(label => {
            label.classList.add('hidden');
            console.log(`Initially hiding color option: ${label.textContent.trim()}`);
        });

        Object.keys(this.config.numberOfColors).forEach(colorName => {
            const price = this.config.pricingMatrix[selectedSize]?.printOptions[printType]?.[colorName];
            const isHidden = this.config.pricingMatrix[selectedSize]?.printOptions[printType]?.[`${colorName}_hidden`];
            console.log(`Checking color: ${colorName}, Price: ${price}, Hidden: ${isHidden}`);
            if (price !== undefined && price !== null && price > 0 && !isHidden) {
                const colorLabel = numberOfColorsFieldset.querySelector(`input[value="${colorName}"]`).parentNode;
                colorLabel.classList.remove('hidden');
                console.log(`Showing color option: ${colorName}`);
            } else {
                console.log(`Keeping color option hidden: ${colorName}`);
            }
        });

        const selectedNumberOfColors = numberOfColorsFieldset.querySelector('input:checked');
        if (!selectedNumberOfColors || selectedNumberOfColors.parentNode.classList.contains('hidden')) {
            const firstVisibleColor = numberOfColorsFieldset.querySelector('label:not(.hidden) input');
            if (firstVisibleColor) {
                firstVisibleColor.checked = true;
                console.log(`Auto-selecting color option: ${firstVisibleColor.value}`);
            }
        }
        console.log('Exiting updateNumberOfColorsOptions');
    }

    formatPrice(price) {
        return price.toFixed(2).replace('.', ',');
    }

    parsePrice(priceString) {
        return parseFloat(priceString.replace(',', '.'));
    }

    calculatePrice() {
        const sizeElement = this.querySelector('input[name="size"]:checked');
        const printTypeElement = this.querySelector('input[name="printType"]:checked');
        const numberOfColorsElement = this.querySelector('input[name="numberOfColors"]:checked');
        const quantityElement = this.querySelector('input[name="quantity"]:checked');
        const shippingOptionElement = this.querySelector('input[name="shipping"]:checked');

        if (!sizeElement || !printTypeElement || !numberOfColorsElement || !quantityElement || !shippingOptionElement) {
            console.warn('Some options are not selected.');
            return;
        }

        const size = sizeElement.value;
        const printType = printTypeElement.value;
        const numberOfColors = numberOfColorsElement.value;
        const quantity = this.config.hiddenOptions.quantity ? 1 : parseInt(quantityElement.value);
        const shippingOption = shippingOptionElement.value;

        const variantOptions = this.config.pricingMatrix[size]?.printOptions[printType];
        if (!variantOptions || variantOptions[numberOfColors] === undefined) {
            console.error(`Missing pricing data for ${size}, ${printType}, ${numberOfColors}`);
            this.querySelector('#price').textContent = 'N/A';
            this.querySelector('#totalPrice').textContent = 'N/A';
            return;
        }

        let basePrice = variantOptions[numberOfColors];
        console.log('Base price:', basePrice);
        
        // Apply quantity multiplier to get adjusted price per unit
        const quantityMultiplier = this.config.quantities[quantity.toString()] || 1;
        const adjustedUnitPrice = basePrice * quantityMultiplier;
        console.log('Quantity multiplier:', quantityMultiplier);
        console.log('Adjusted unit price:', adjustedUnitPrice);

        // Check if the color option is CMYK
        const colorInfo = this.config.numberOfColors[numberOfColors];
        const isCMYK = typeof colorInfo === 'object' && colorInfo.isCMYK;
        
        let clicheCost = 0;
        const selectedPrintType = this.config.printTypes.find(pt => pt.name === printType);
        const isDoubleSided = selectedPrintType && selectedPrintType.isDoubleSided;
        
        if (isCMYK) {
            // For CMYK, use the fixed costs
            clicheCost = isDoubleSided ? 
                (this.config.fixedCostCMYKDouble || this.config.fixedCostCMYK) : 
                this.config.fixedCostCMYK;
            console.log('Using CMYK fixed cost:', clicheCost);
        } else {
            // For regular colors, calculate based on number of colors
            const numberOfColorsValue = typeof colorInfo === 'object' ? colorInfo.number : colorInfo;
            clicheCost = this.config.clicheCostPerColor * numberOfColorsValue;
            
            if (isDoubleSided) {
                clicheCost *= 2;
            }
            console.log('Using regular cliche cost per color:', clicheCost);
        }

        console.log('Selected print type:', selectedPrintType);
        console.log('Total cliche cost:', clicheCost);

        // Calculate total price with adjusted unit price
        let totalPrice = (adjustedUnitPrice * quantity) + clicheCost;
        console.log('Total price after cliche cost:', totalPrice);
    

        const shippingOptions = variantOptions[`${numberOfColors}_shipping`];
        let shippingCost = 0;

        const variantShippingOptions = this.parseOptions(shippingOptions || '');
        if (variantShippingOptions[shippingOption] && variantShippingOptions[shippingOption] !== 'hidden') {
            shippingCost = parseFloat(variantShippingOptions[shippingOption]);
        } else {
            const globalShippingOption = this.config.shipping[shippingOption];
            if (globalShippingOption) {
                if (globalShippingOption.type === 'percentage') {
                    shippingCost = totalPrice * (globalShippingOption.value / 100);
                } else if (globalShippingOption.type === 'fixed') {
                    shippingCost = globalShippingOption.value;
                }
            }
        }

        console.log('Shipping cost:', shippingCost);
        totalPrice += shippingCost;
        console.log('Total price after shipping:', totalPrice);

        const imagePosition = sizeElement.dataset.imagePosition;
        console.log('Image position:', imagePosition);
        if (imagePosition) {
            document.querySelector('.product__media-list')?.swiper?.slideTo(parseInt(imagePosition) - 1);
        }


        this.querySelector('#price').textContent = `${window.currentCurrency}${this.formatPrice(adjustedUnitPrice)}`;
        this.querySelector('#totalPrice').textContent = `${window.currentCurrency}${this.formatPrice(totalPrice)}`;
        this.querySelector('#pricePerItem').textContent = `${window.currentCurrency}${this.formatPrice(totalPrice / quantity)}`;
        this.querySelector('#additionalPricePerPiece').textContent = `${window.currentCurrency}${this.formatPrice(totalPrice / quantity)}`;

        this.updateCurrentItemsCount();

        this.updateShippingPrices(totalPrice - shippingCost, shippingCost);
        this.updateSKU();

    }


    updateQuantityOptions() {
        const quantityFieldset = this.querySelector('#quantityFieldset');
        const sizeElement = this.querySelector('input[name="size"]:checked');
        const printTypeElement = this.querySelector('input[name="printType"]:checked');
        const numberOfColorsElement = this.querySelector('input[name="numberOfColors"]:checked');

        if (!sizeElement || !printTypeElement || !numberOfColorsElement) {
            console.warn('Some options are not selected.');
            return;
        }

        const size = sizeElement.value;
        const printType = printTypeElement.value;
        const numberOfColors = numberOfColorsElement.value;

        const variantOptions = this.config.pricingMatrix[size]?.printOptions[printType];
        const quantityOptionsString = variantOptions?.[`${numberOfColors}_quantity`] || '';
        const quantityOptions = this.parseOptions(quantityOptionsString);

        console.log('Quantity options:', quantityOptions);

        console.log('Quantity options string:', quantityOptionsString);
        console.log('Parsed quantity options:', quantityOptions);

        let allHidden = true;
        quantityFieldset.querySelectorAll('label').forEach(label => {
            const quantityValue = label.querySelector('input').value;
            if (quantityOptions[quantityValue] === 'hidden' || quantityOptionsString.includes(`${quantityValue}:hidden`)) {
                label.style.display = 'none';
            } else {
                label.style.display = 'block';
                allHidden = false;
            }
        });


        if (allHidden) {
            quantityFieldset.style.display = 'none';
        } else {
            quantityFieldset.style.display = 'block';
        }

        // Ensure a valid quantity is selected
        const selectedQuantity = quantityFieldset.querySelector('input:checked');
        if (!selectedQuantity || selectedQuantity.parentNode.style.display === 'none') {
            const firstVisibleQuantity = quantityFieldset.querySelector('label:not([style*="display: none"]) input');
            if (firstVisibleQuantity) {
                firstVisibleQuantity.checked = true;
            }
        }
    }


    updateShippingPrices(basePrice, currentShippingCost) {
        const sizeElement = this.querySelector('input[name="size"]:checked');
        const printTypeElement = this.querySelector('input[name="printType"]:checked');
        const numberOfColorsElement = this.querySelector('input[name="numberOfColors"]:checked');

        const size = sizeElement.value;
        const printType = printTypeElement.value;
        const numberOfColors = numberOfColorsElement.value;

        const variantOptions = this.config.pricingMatrix[size]?.printOptions[printType];
        const variantShippingOptionsString = variantOptions?.[`${numberOfColors}_shipping`] || '';
        const variantShippingOptions = this.parseOptions(variantShippingOptionsString);

        console.log('UpdateShippingPrices - Variant shipping options:', variantShippingOptions);

        const shippingInputs = this.querySelectorAll('#shippingFieldset input[type="radio"]');
        let firstVisibleShippingInput = null;
        let selectedShippingInput = this.querySelector('#shippingFieldset input[type="radio"]:checked');

        console.log('Variant shipping options string:', variantShippingOptionsString);
        console.log('Parsed variant shipping options:', variantShippingOptions);

        shippingInputs.forEach(input => {
            const shippingName = input.value;
            let shippingCost = 0;

            if (variantShippingOptions[shippingName] === 'hidden') {
                input.parentElement.style.display = 'none';
            } else {
                input.parentElement.style.display = 'block';
                if (!firstVisibleShippingInput) {
                    firstVisibleShippingInput = input;
                }

                // Check if there's a variant-specific shipping cost
                if (variantShippingOptions[shippingName] && variantShippingOptions[shippingName] !== 'hidden') {
                    shippingCost = parseFloat(variantShippingOptions[shippingName]);
                } else {
                    // Fall back to global shipping options if no variant-specific cost
                    const globalShippingOption = this.config.shipping[shippingName];
                    if (globalShippingOption) {
                        if (globalShippingOption.type === 'percentage') {
                            shippingCost = basePrice * (globalShippingOption.value / 100);
                        } else if (globalShippingOption.type === 'fixed') {
                            shippingCost = globalShippingOption.value;
                        }
                    }
                }

                const totalPriceWithShipping = basePrice + shippingCost;
                input.nextSibling.textContent = ` ${shippingName} - ${window.currentCurrency}${this.formatPrice(totalPriceWithShipping)}`;
            }

            console.log(`Shipping option: ${shippingName}, Cost: ${shippingCost}`);
        });



        // Ensure a valid shipping option is selected
        if (!selectedShippingInput || selectedShippingInput.parentElement.style.display === 'none') {
            if (firstVisibleShippingInput) {
                firstVisibleShippingInput.checked = true;
                console.log(`Auto-selecting shipping option: ${firstVisibleShippingInput.value}`);
            }
        }
    }



    toggleFileUpload() {
        const fileUploadContainer = this.querySelector('#fileUploadContainer');
        const selectedValue = this.querySelector('input[name="ontwerpAanleveren"]:checked').value;
        fileUploadContainer.style.display = selectedValue === 'nu' ? 'block' : 'none';
    }


    updateCart() {
      const fetchAndUpdateCart = () => {
          fetch(window.location.href)
              .then(response => response.text())
              .then(html => {
                  const parser = new DOMParser();
                  const doc = parser.parseFromString(html, 'text/html');
                  
                  // Update cart icon
                  const cartIconBubble = document.querySelector('a#cart-icon-bubble');
                  if (cartIconBubble) {
                      cartIconBubble.innerHTML = doc.querySelector('a#cart-icon-bubble').innerHTML;
                      cartIconBubble.click(); // Open cart drawer
                  }
                  
                  // Update cart drawer
                  const cartDrawer = document.querySelector('cart-drawer');
                  if (cartDrawer) {
                      cartDrawer.innerHTML = doc.querySelector('cart-drawer').innerHTML;
                      cartDrawer.classList.remove('is-empty');
                  }
                  
                  // Update button state
                  const addToCartBtn = document.querySelector('#addToCartBtn');
                  if (addToCartBtn) {
                      addToCartBtn.classList.remove('is-loading');
                      addToCartBtn.classList.add('is-adding');
                  }
                  
                  // Check if the cart item image is present
                  const cartItemImage = document.querySelector('div#CartDrawer-Item-1 .cart-item__media');
                  if (!cartItemImage) {
                      console.log('Cart item image not found. Retrying...');
                      setTimeout(fetchAndUpdateCart, 1000); // Retry after 1 second
                  } else {
                      console.log('Cart updated successfully');
                      // Remove 'is-adding' class after a short delay
                      setTimeout(() => {
                          if (addToCartBtn) {
                              addToCartBtn.classList.remove('is-adding');
                          }
                      }, 2000);
                  }
              })
              .catch(err => {
                  console.warn('Something went wrong while updating the cart:', err);
                  setTimeout(fetchAndUpdateCart, 1000); // Retry after 1 second in case of error
              });
      };
  
      fetchAndUpdateCart();
  }

    async addToCart() {
        this.querySelector('#addToCartBtn').classList.add('is-adding');
        const sizeElement = this.querySelector('input[name="size"]:checked');
        const printTypeElement = this.querySelector('input[name="printType"]:checked');
        const numberOfColorsElement = this.querySelector('input[name="numberOfColors"]:checked');
        const quantityElement = this.querySelector('input[name="quantity"]:checked');
        const shippingOptionElement = this.querySelector('input[name="shipping"]:checked');
        const fileInput = this.querySelector('input[type="file"]');

        if (!sizeElement || !printTypeElement || !numberOfColorsElement || !quantityElement || !shippingOptionElement) {
            alert('Please select all options before adding to cart.');
            return;
        }

        const size = sizeElement.value;
        const printType = printTypeElement.value;
        const numberOfColors = numberOfColorsElement.value;
        const quantity = parseInt(quantityElement.value);
        const shippingOption = shippingOptionElement.value;

        const totalPriceString = this.querySelector('#totalPrice').textContent.replace(window.currentCurrency, '');
        const totalPrice = this.parsePrice(totalPriceString);

        if (isNaN(totalPrice)) {
            alert('Failed to calculate total price. Please check your inputs.');
            return;
        }

        try {
            const customVariantResponse = await fetch(this.endpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    productId: this.productId,
                    price: totalPrice
                }),
            });

            if (!customVariantResponse.ok) {
                throw new Error('Failed to get custom variant');
            }

            const { variantId } = await customVariantResponse.json();

            const properties = {
                'Size': size,
                'Print Type': printType,
                'Number of Colors': numberOfColors,
                'Quantity': quantity,
                'Shipping Option': shippingOption,
                'Calculated Price': `${window.currentCurrency}${totalPrice.toFixed(2)}`
            };

            if (this.uploadedFileUrl) {
                properties['Design Upload'] = this.uploadedFileUrl;
            }

            const cartData = {
                items: [{
                    id: variantId,
                    quantity: 1,
                    properties: properties
                }]
            };

            const addToCartResponse = await fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(cartData),
            });

            if (!addToCartResponse.ok) {
                throw new Error('Failed to add to cart');
            }

            console.log('Item added to cart successfully!');

            
            
            setTimeout(this.updateCart, 5500);


        } catch (error) {
            console.error('Error adding to cart:', error);
            alert('Failed to add item to cart. Please try again.');
        }
    }


}

if (!customElements.get('product-price-calculator')) {
    customElements.define('product-price-calculator', ProductPriceCalculator);
}